/* WGC fitment safeguards. Read-only cart matching; never changes a price or cart automatically. */
(function () {
  'use strict';
  function list(value) { return Array.isArray(value) ? value : (value ? [value] : []); }
  function norm(value) { return String(value || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }
  function canonical(value) {
    var n = norm(value), aliases = {drive:'g29',g29drive:'g29',driveg29:'g29',ydre2:'drive2',precedentiq:'precedent',precedentiqexcel:'precedent',dsiq:'ds',dsiqexcel:'ds'};
    return aliases[n] || n;
  }
  function tokens(value) { return String(value || '').split(/[/,]/).map(canonical).filter(Boolean); }
  function modelMatches(values, wanted) {
    if (!wanted || /^all\b/i.test(wanted)) return false;
    var wants = tokens(wanted);
    return list(values).some(function (value) { return tokens(value).some(function (token) { return wants.indexOf(token) !== -1; }); });
  }
  function brandMatches(values, wanted) { return list(values).some(function (value) { return norm(value) === norm(wanted); }); }
  function voltageMatches(values, wanted) {
    var w = Number.parseFloat(String(wanted || ''));
    if (!Number.isFinite(w) || !list(values).length) return null;
    var known = false;
    var matched = list(values).some(function (value) {
      var s = String(value), range = s.match(/(\d+(?:\.\d+)?)\s*v?\s*(?:[-\u2013\u2014]|\bto\b)\s*(\d+(?:\.\d+)?)\s*v?\b/i);
      var nums = s.match(/\d+(?:\.\d+)?/g);
      if (!nums) return false;
      known = true;
      if (range) return w >= Math.min(Number(range[1]),Number(range[2])) && w <= Math.max(Number(range[1]),Number(range[2]));
      return nums.some(function (n) { return Math.abs(Number(n)-w) < 0.05; });
    });
    return known ? matched : null;
  }
  function powerMatches(values, wanted) {
    if (!wanted || !list(values).length) return null;
    var s = list(values).join(' ').toLowerCase();
    if (norm(wanted) === 'gas') return /\bgas\b|gasoline|petrol/.test(s);
    if (norm(wanted) === 'electric') return /electric|\b(?:ac|dc|regen|series)\b/.test(s);
    return null;
  }
  function yearMatches(range, year, model) {
    var y = Number(year);
    if (!range || !Number.isInteger(y) || y < 1960 || y > 2030) return null;
    var text = String(range).replace(/[\u2013\u2014]/g,'-');
    if (/conflict|inconsisten|manufacturer title|description says|verify|confirm|unless|except|not verified|no specific|does not|not publish/i.test(text)) return null;
    var wanted = Array.from(new Set(tokens(model)));
    if (wanted.length !== 1) return null;
    function scope(part) {
      var found = part.match(/\b(?:precedent|tempo|onward|carryall|villager|marathon|medalist|txt|t48|rxv|valor|ds|g\d{1,2}|drive\s*2|drive)\b/gi) || [];
      return found.map(canonical);
    }
    var parts = text.split(';').map(function (part) { return part.trim(); }).filter(Boolean);
    var scoped = parts.some(function (part) { return scope(part).length; });
    if (scoped) {
      parts = parts.filter(function (part) { return scope(part).indexOf(wanted[0]) !== -1; });
      if (!parts.length) return null;
    }
    function matchPart(part) {
      if (/all (?:model )?years|any year|year not restricted/i.test(part)) return true;
      var nums = part.match(/\b(?:19|20)\d{2}(?:\.5)?\b/g);
      if (!nums || nums.length > 2) return null;
      var lo = Number(nums[0]);
      if (/\b(?:19|20)\d{2}-\d{2}-\d{2}\b/.test(part)) {
        if (y === Math.floor(lo)) return null;
        return /before|earlier/i.test(part) ? y < lo : null;
      }
      if (nums.some(function(n){return Number(n)%1 && y===Math.floor(Number(n));})) return null;
      if (nums.length===2) {
        var hi=Number(nums[1]);
        if(lo>hi || !/(?:19|20)\d{2}(?:\.5)?\s*(?:-|to|through)\s*(?:19|20)\d{2}(?:\.5)?/i.test(part)) return null;
        return y>=lo && y<=hi;
      }
      if (/\bpre\s*-|\bbefore\b/i.test(part)) return y<lo;
      if (/earlier|older|through/i.test(part)) return y<=lo;
      if (/\b(?:up|newer|present|current)\b|\+|\b(?:19|20)\d{2}(?:\.5)?\s+onward\b/i.test(part)) return y>=lo;
      return y===lo;
    }
    var outcomes=parts.map(matchPart);
    if(outcomes.some(function(v){return v===null;})) return null;
    if(outcomes.length>1 && outcomes.some(function(v){return v!==outcomes[0];})) return null;
    return outcomes.length ? outcomes[0] : null;
  }
  function isPowertrain(item) { return list(item.tags).indexOf('Powertrain Bundles') !== -1; }
  function bundleMatches(item, profile) {
    if (!profile || !profile.year || !brandMatches(item.brands,profile.brand) || !modelMatches(item.models,profile.model)) return false;
    if (yearMatches(item.years,profile.year,profile.model) === false) return false;
    if (powerMatches(item.drivetrain,profile.power) === false || voltageMatches(item.voltage,profile.voltage) === false) return false;
    if (isPowertrain(item) && (norm(profile.power) !== 'electric' || voltageMatches(item.voltage,profile.voltage) !== true)) return false;
    return true;
  }
  var engine = {list:list,norm:norm,canonical:canonical,modelsMatch:modelMatches,brandMatches:brandMatches,voltageMatches:voltageMatches,powerMatches:powerMatches,yearMatch:yearMatches,matches:bundleMatches};
  window.WgcFitmentEngine = engine;
  window.WgcBundleFitment = engine;
  function json(id) { try { var el = document.getElementById(id); return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; } }
  function profile() { try { return JSON.parse(localStorage.getItem('wgcFitmentProfile') || sessionStorage.getItem('wgcFitmentProfile') || 'null'); } catch (e) { return null; } }
  function save(value) { ['localStorage','sessionStorage'].forEach(function (key) { try { window[key].setItem('wgcFitmentProfile',JSON.stringify(value)); } catch (e) {} }); }
  function localUrl(path) {
    var u = new URL(path,location.origin);
    if (u.origin !== location.origin) throw new Error('External fitment destination');
    var preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (preview) u.searchParams.set('preview_theme_id',preview);
    return u.pathname + u.search;
  }
  function initSavedForm() { /* Form routing is owned by wgc-fitment-finder.js. */ }
  function initProduct(config) {
    var box = document.getElementById('WgcSavedFitmentCheck'), output = box && box.querySelector('[data-wgc-fitment-result]'), saved = profile();
    if (!output || !saved) return;
    var data = json('WgcProductFitmentData'), product = config.product || {}, labels = config.labels || {}, checks = [];
    if (saved.brand) checks.push(list(data.brands).length ? brandMatches(data.brands,saved.brand) : null);
    if (saved.model) checks.push(modelMatches(data.models,saved.model));
    if (saved.year) checks.push(yearMatches(data.years,saved.year,saved.model));
    if (saved.voltage) checks.push(voltageMatches(data.voltage,saved.voltage));
    if (saved.power) checks.push(powerMatches(data.drivetrain,saved.power));
    var complete = saved.brand && saved.model && !/^all\b/i.test(saved.model) && saved.year && saved.voltage && saved.power;
    var primary = false; try { primary = /^(?:www\.)?(?:alltraxinc\.com|ddmotorsystems\.com|shop\.fsip\.biz|steelenggolfcart\.com|10l0l\.com|boltenergyusa\.com|ridemodz\.com|ecobattery\.com|navitasvs\.com|nivelparts\.com)$/.test(new URL(product.source).hostname); } catch (e) {}
    var verified = !product.reviewRequired && !data.reviewRequired && !product.technical && !product.wheel && complete && primary && data.verified === true && checks.length === 5 && checks.every(function (check) { return check === true; }) && !/\.5|\bunless\b|\bexcept\b/i.test(String(data.years || ''));
    box.classList.toggle('wgc-saved-fitment--match',!!verified);
    box.classList.toggle('wgc-saved-fitment--warning',!verified && !product.wheel);
    output.replaceChildren();
    var strong = document.createElement('strong'); strong.textContent = checks.some(function(check){return check === false;}) && !product.wheel ? 'This listing does not match your saved cart. Check the application before ordering.' : (product.wheel ? labels.universal : (verified ? labels.verified : labels.check)); output.appendChild(strong);
    var note = document.createElement('p'); note.textContent = labels.review; note.style.margin = '5px 0'; output.appendChild(note);
    var link = document.createElement('a'); link.textContent = labels.requirements; link.href = product.guide || '/pages/golf-cart-fitment-help'; output.appendChild(link);
    box.hidden = false;
  }
  function initACGuard(config) {
    var sel = document.getElementById('WgcPowertrainSolenoidSelect'), target = document.getElementById('WgcPowertrainTargetVoltage'), root = document.getElementById('WgcPowertrainFinder');
    if (!sel || !target || !root || root.dataset.wgcSafetyGuard) return;
    root.dataset.wgcSafetyGuard = 'true';
    var labels = config.labels || {}, catalog = json('WgcPowertrainCatalog'), forbidden = sel.querySelector('option[value="72"]'), warning = document.getElementById('WgcPowertrainSolenoidWarning');
    if (forbidden) forbidden.remove();
    var notice = document.createElement('p'); notice.className = 'wgc-powertrain-addon__warning';
    var limit = document.createElement('strong'); limit.textContent = catalog.solenoids && catalog.solenoids['72'] ? catalog.solenoids['72'].title : labels.check; notice.appendChild(limit);
    notice.appendChild(document.createTextNode(' · '));
    var guide = document.createElement('a'); guide.href = '/pages/mzj-solenoid-fitment-guide'; guide.textContent = labels.requirements; notice.appendChild(guide);
    sel.closest('.wgc-powertrain-addon__card').appendChild(notice);
    function apply() {
      var highVoltage = Number(target.value) > 60;
      sel.disabled = highVoltage;
      if (highVoltage && sel.value) { sel.value = ''; sel.dispatchEvent(new Event('change',{bubbles:true})); }
      if (highVoltage && warning) warning.textContent = limit.textContent;
    }
    target.addEventListener('change',function () { queueMicrotask(apply); });
    root.addEventListener('change',function (event) { if (event.target !== sel) queueMicrotask(apply); });
    root.addEventListener('click',function (event) { if (event.target.closest('.wgc-powertrain-add-cart')) apply(); },true);
    apply();
  }
  function init() { var config = json('WgcFitmentGuardConfig'); initSavedForm(); initProduct(config); initACGuard(config); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
